export const SITE_CONTENT_DEFAULTS = {
  home_hero: {
    badge: 'Autorité administrative indépendante',
    title: 'Votre voix compte.',
    highlight: 'La médiation pour tous.',
    subtitle:
      "Le médiateur est l'intercesseur entre l'Administration publique et les citoyens. Déposez votre réclamation en toute transparence et confidentialité.",
    primaryButtonLabel: 'Déposer une réclamation',
    primaryButtonLink: '/services/depot-plainte',
    secondaryButtonLabel: 'Suivre ma réclamation',
    secondaryButtonLink: '/services/suivi',
    featureOne: 'Gratuit et confidentiel',
    featureTwo: "À l'écoute de tous"
  },
  home_stats: {
    items: [
      { target: 126, label: 'Réclamations reçues', trend: '+12%' },
      { target: 80, label: 'Taux de résolution', suffix: '%', trend: '+5%' },
      { target: 23, label: 'Régions couvertes', trend: '100%' },
      { target: 420, label: 'Médiateurs formés', trend: '+23' }
    ]
  },
  home_quick_access: {
    subtitle: 'Nos Services',
    title: 'Accès rapides',
    description: 'Tous nos services sont gratuits, confidentiels et accessibles à tous les citoyens tchadiens.',
    ctaLabel: 'Accéder',
    items: [
      {
        icon: 'FileText',
        title: 'Déposer une réclamation',
        description: 'Formulaire en ligne sécurisé pour soumettre votre réclamation en toute confidentialité.',
        link: '/services/depot-plainte'
      },
      {
        icon: 'Search',
        title: 'Suivre ma réclamation',
        description: "Consultez en temps réel l'état d'avancement de votre dossier de médiation.",
        link: '/services/suivi'
      },
      {
        icon: 'Map',
        title: 'Observatoire des conflits',
        description: 'Carte interactive des zones de tension et actions de médiation en cours.',
        link: '/observatoire'
      },
      {
        icon: 'BookOpen',
        title: 'Textes juridiques',
        description: 'Accédez aux lois, décrets et règlements sur la médiation au Tchad.',
        link: '/documents/textes-juridiques'
      },
      {
        icon: 'Users',
        title: 'Nos partenaires',
        description: 'Institutions et organisations avec lesquelles nous collaborons.',
        link: '/partenaires'
      },
      {
        icon: 'MessageCircle',
        title: 'Contactez-nous',
        description: 'Envoyez-nous un message, notre équipe vous répondra dans les plus brefs délais.',
        link: '/contact'
      }
    ]
  },
  home_testimonial: {
    quote:
      "La médiation est un outil puissant pour renforcer la confiance entre les citoyens et leur administration. Notre engagement est de rendre la justice accessible à tous.",
    author: 'Amb Saleh KEBZABO',
    role: 'Médiateur de la République du Tchad'
  },
  services_page: {
    title: 'Nos Services',
    subtitle: 'Des solutions accessibles et transparentes pour chaque citoyen',
    ctaLabel: 'Accéder',
    items: [
      {
        icon: 'FileText',
        title: 'Déposer une réclamation',
        description: 'Formulaire en ligne sécurisé et confidentiel pour soumettre votre réclamation en quelques minutes.',
        link: '/services/depot-plainte'
      },
      {
        icon: 'Search',
        title: 'Suivre ma réclamation',
        description: "Consultez en temps réel l'état d'avancement de votre dossier avec un numéro de suivi unique.",
        link: '/services/suivi'
      },
      {
        icon: 'BookOpen',
        title: 'Méthodologie',
        description: 'Découvrez notre approche de médiation transparente et respectueuse de toutes les parties.',
        link: '/services/methodologie'
      },
      {
        icon: 'HeadphonesIcon',
        title: 'Assistance téléphonique',
        description: "Notre équipe vous assiste pour toute question ou orientation via le formulaire de contact.",
        link: '/contact'
      },
      {
        icon: 'FileText',
        title: 'Formulaires',
        description: 'Téléchargez les formulaires officiels pour vos démarches administratives.',
        link: '/services/formulaires'
      },
      {
        icon: 'ArrowRight',
        title: 'Guide des démarches',
        description: 'Parcours simple et clair pour chaque type de réclamation ou de demande.',
        link: '/services/guide'
      }
    ]
  },
  contact_page: {
    heroTitle: 'Contactez-nous',
    heroSubtitle: "Notre équipe est à votre écoute pour toute question, suggestion ou demande d'assistance",
    formTitle: 'Envoyez-nous un message',
    formSubtitle: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais',
    socialTitle: 'Suivez-nous sur les réseaux sociaux',
    cards: [
      {
        icon: 'MapPin',
        title: 'Adresse',
        lines: ['Avenue Colonel NELDE ROGOBER', "BP: 898, N'Djamena", 'Tchad']
      },
      {
        icon: 'Mail',
        title: 'Email',
        links: [
          { label: 'contact@mediature.td', href: 'mailto:contact@mediature.td' },
          { label: 'reclamations@mediature.td', href: 'mailto:reclamations@mediature.td' }
        ]
      },
      {
        icon: 'Clock',
        title: 'Horaires',
        lines: ['Lundi - Vendredi', '8h00 - 12h00', '14h00 - 16h00']
      }
    ],
    socialLinks: [
      { icon: 'Facebook', url: '#', color: '#1877f2' },
      { icon: 'Twitter', url: '#', color: '#1da1f2' },
      { icon: 'Linkedin', url: '#', color: '#0077b5' }
    ],
    faqTitle: 'Questions fréquentes',
    faq: [
      {
        question: 'Comment déposer une réclamation auprès de la Médiature ?',
        answer:
          'Vous pouvez déposer une réclamation en ligne via notre formulaire sécurisé, par e-mail, par courrier postal ou en personne à notre siège. Toutes les méthodes sont gratuites et confidentielles.'
      },
      {
        question: "Quel est le délai de traitement d'une réclamation ?",
        answer:
          "Le délai moyen de traitement est de 30 jours ouvrables. Certaines affaires complexes peuvent nécessiter plus de temps, mais vous serez informé régulièrement de l'avancement."
      },
      {
        question: 'La Médiature peut-elle annuler une décision administrative ?',
        answer:
          "Non, la Médiature ne peut pas annuler ou réformer une décision administrative. Elle émet des recommandations que l'administration n'est pas obligée de suivre, mais qui ont un fort pouvoir de persuasion."
      },
      {
        question: 'Les services de la Médiature sont-ils payants ?',
        answer:
          'Non, tous les services de la Médiature sont entièrement gratuits. Le médiateur est une autorité administrative indépendante dont la mission est de servir les citoyens.'
      },
      {
        question: 'Puis-je déposer une réclamation anonymement ?',
        answer:
          "Oui, il est possible de déposer une réclamation anonyme. Cependant, cela peut limiter nos capacités à vous tenir informé de l'avancement et à obtenir des éléments de réponse."
      },
      {
        question: 'Quels types de litiges la Médiature ne traite-t-elle pas ?',
        answer:
          "La Médiature ne traite pas les litiges entre particuliers, les affaires en cours devant les tribunaux, les décisions juridictionnelles définitives et les affaires relevant d'institutions à immunité internationale."
      }
    ]
  },
  institution_page: {
    heroTitle: "L'Institution",
    heroSubtitle: "Autorité administrative indépendante investie d'une mission de service public de médiation",
    leadersTitle: 'Équipe dirigeante',
    missionsTitle: 'Rôle et missions',
    limitsTitle: 'Pouvoirs et Limites',
    leaders: [
      { initials: 'SK', name: 'Ambassadeur Saleh KEBZABO', role: 'Médiateur de la République' },
      { initials: 'AA', name: 'AHIDJO ABRAHAM', role: 'Secrétaire général' },
      { initials: 'DM', name: 'DJIBRINE MOUSSA MAHAMAT', role: 'Secrétaire général adjoint' },
      { initials: 'MS', name: 'MAHAMADOU MAHAMAT SOULEYMANE', role: 'Directeur de Cabinet' }
    ],
    missions: [
      'Recevoir les réclamations relatives au fonctionnement des administrations',
      'Instruire les dysfonctionnements des services publics',
      'Proposer des règlements amiables des litiges',
      "Participer à l'amélioration des services publics",
      'Contribuer à la réconciliation nationale et à la cohésion sociale'
    ],
    limits: [
      "Peut se saisir d'office de toute question relevant de sa compétence",
      'Peut recevoir des alertes sur des situations de tension communautaire',
      "N'est pas compétente pour les conflits entre personnes privées",
      "N'intervient pas dans les procédures judiciaires",
      "Ne peut pas imposer de décision à l'administration"
    ]
  },
  equipe_dirigeante_page: {
    heroTitle: 'Équipe dirigeante',
    heroSubtitle: "Découvrez les membres de l'équipe qui font fonctionner la Médiature de la République",
    mediatorBadge: 'Médiateur de la République',
    mediatorName: 'Ambassadeur Saleh KEBZABO',
    mediatorBio:
      "L'Ambassadeur Saleh KEBZABO est le Médiateur de la République depuis février 2024. Ancien Premier ministre et haut cadre politique, il incarne l'indépendance et la neutralité de l'institution dans sa mission d'intercession entre l'administration publique et les citoyens.",
    mediatorPhotoKey: 'mediateur',
    secretariatTitle: 'Secrétariat général',
    secretariatGeneral: [
      {
        name: 'AHIDJO ABRAHAM',
        role: 'Secrétaire général',
        photoKey: 'sg'
      },
      {
        name: 'DJIBRINE MOUSSA MAHAMAT',
        role: 'Secrétaire général adjoint',
        photoKey: 'sga'
      }
    ],
    cabinetTitle: 'Direction de Cabinet',
    cabinetDirector: {
      name: 'MAHAMADOU MAHAMAT SOULEYMANE',
      role: 'Directeur de Cabinet',
      photoKey: 'dircab'
    },
    directionsTitle: 'Directions',
    directions: [
      'Direction des Affaires administratives, financières et du matériel',
      'Direction des Études et de la Gestion des Conflits',
      'Direction de la Coopération et des Relations internationales',
      "Direction de la Communication, de la Documentation, de l'Informatique et de la Traduction"
    ],
    conseillersTechniquesTitle: 'Conseillers techniques',
    conseillersTechniques: [
      'Conseiller Technique N1',
      'Conseiller Technique N2',
      'Conseiller Technique N3',
      'Conseiller Technique N4',
      'Conseiller Technique N5',
      'Conseiller Technique N6',
      'Conseiller Technique N7',
      'Conseiller Technique N8',
      'Conseiller Technique N9',
      'Conseiller Technique N10',
      'Conseiller Technique N11'
    ],
    conseillersMissionsTitle: 'Conseillers chargés de mission',
    conseillersMissions: [
      'Conseiller chargé de mission N1',
      'Conseiller chargé de mission N2',
      'Conseiller chargé de mission N3',
      'Conseiller chargé de mission N4'
    ]
  },
  partenaires_page: {
    heroTitle: 'Institutions Partenaires',
    heroSubtitle:
      "La Médiature de la République collabore avec un réseau diversifié d'institutions pour renforcer la protection des citoyens et promouvoir la bonne gouvernance",
    introTitle: 'Notre réseau de partenaires',
    introText:
      "Les partenariats stratégiques de la Médiature permettent d'amplifier son impact et d'assurer une couverture nationale efficace. Ensemble, nous œuvrons pour renforcer la confiance entre les citoyens et l'administration publique.",
    groups: [
      {
        icon: 'Building2',
        title: 'Ministères et administrations publiques',
        items: [
          'Ministère de la Justice',
          "Ministère de l'Intérieur",
          'Ministère des Affaires étrangères',
          'Ministère de la Fonction publique',
          'Ministère de la Décentralisation',
          'Ministère des Finances',
          'Ministère de la Santé',
          "Ministère de l'Éducation nationale"
        ]
      },
      {
        icon: 'Scale',
        title: 'Institutions nationales des droits humains',
        items: [
          'Commission Nationale des Droits Humains (CNDH)',
          'Commission électorale nationale indépendante (CENI)',
          'Cour suprême',
          'Conseil Constitutionnel',
          'Cour des Comptes',
          'Institut National de la Statistique',
          'Centre de Formation aux Métiers du Droit'
        ]
      },
      {
        icon: 'Users',
        title: 'Associations citoyennes et ONG',
        items: [
          'Réseau des Associations de Défense des Droits Humains (RADDHU)',
          "Ligue Tchadienne des Droits de l'Homme (LTDH)",
          'Association pour la Promotion des Libertés fondamentales',
          'ONG AEC',
          'Croix-Rouge du Tchad',
          'Association des Femmes Juristes',
          'Plateforme des ONG du Tchad'
        ]
      },
      {
        icon: 'Gavel',
        title: 'Tribunaux et structures de médiation locales',
        items: [
          "Cour d'Appel de N'Djamena",
          'Tribunal de Grande Instance',
          "Tribunaux d'Arrondissement",
          'Justices de Paix',
          'Conseils Coutumiers',
          'Médiateurs communautaires',
          'Associations de leaders religieux et traditionnels'
        ]
      }
    ]
  },
  documents_page: {
    title: 'Documents Officiels',
    subtitle: 'Accédez aux textes juridiques, rapports et publications de la Médiature',
    textesTitle: 'Textes Juridiques',
    rapportsTitle: 'Rapports & Études',
    downloadLabel: 'Télécharger',
    textesJuridiques: [
      { title: 'Constitution du Tchad (2025)', date: '08 oct 2025' },
      { title: 'Loi N010/PR/2025 - Médiature', date: '05 août 2025' },
      { title: 'Règlement intérieur', date: '01 jan 2024' }
    ],
    rapports: [
      { title: 'Rapport annuel 2024', date: '10 déc 2024' },
      { title: "Rapport d'activité Q3 2024", date: '15 oct 2024' },
      { title: 'Étude sur les conflits communautaires', date: '03 juin 2024' }
    ]
  }
};

export const SITE_CONTENT_SECTIONS = [
  {
    key: 'home_hero',
    label: 'Accueil - Bannière',
    description: "Bandeau principal de la page d'accueil."
  },
  {
    key: 'home_stats',
    label: 'Accueil - Statistiques',
    description: "Cartes chiffres de la page d'accueil."
  },
  {
    key: 'home_quick_access',
    label: 'Accueil - Accès rapides',
    description: "Blocs de navigation rapide de la page d'accueil."
  },
  {
    key: 'home_testimonial',
    label: 'Accueil - Citation',
    description: "Citation institutionnelle en bas de la page d'accueil."
  },
  {
    key: 'services_page',
    label: 'Page Services',
    description: 'Titre, sous-titre et cartes de la page Services.'
  },
  {
    key: 'contact_page',
    label: 'Page Contact',
    description: 'Bandeau, cartes contact, réseaux et FAQ.'
  },
  {
    key: 'institution_page',
    label: 'Page Institution',
    description: 'Contenus institutionnels (équipe, missions, limites).'
  },
  {
    key: 'equipe_dirigeante_page',
    label: 'Page Équipe dirigeante',
    description: 'Informations du médiateur et de la structure.'
  },
  {
    key: 'partenaires_page',
    label: 'Page Partenaires',
    description: 'Titres et listes des institutions partenaires.'
  },
  {
    key: 'documents_page',
    label: 'Page Documents',
    description: 'Listes de documents affichées dans la page Documents.'
  }
];
